// calculates the next monday for sending the internal messages
export function getSendingDate(): Date {
  const dayINeed = 1; // for monday
  const today = new Date();

  if (today.getDay() < dayINeed) {
    // today is sunday (0) so just take tomorrow
    today.setDate(today.getDate() + 1);
    return today;
  } else if (today.getDay() === dayINeed) {
    // if it's exactly the day I need, then give me today
    return today;
  } else {
    // otherwise, give me *next week's* instance of that same day
    const diffToMonday = (dayINeed + 7 - today.getDay()) % 7;
    today.setDate(today.getDate() + diffToMonday);
    return today;
  }
}
